const phoneCountries = [
  { code: "CR", name: "Costa Rica", dialCode: "+506" },
  { code: "US", name: "Estados Unidos", dialCode: "+1" },
  { code: "MX", name: "Mexico", dialCode: "+52" },
  { code: "PA", name: "Panama", dialCode: "+507" },
  { code: "GT", name: "Guatemala", dialCode: "+502" },
  { code: "SV", name: "El Salvador", dialCode: "+503" },
  { code: "HN", name: "Honduras", dialCode: "+504" },
  { code: "NI", name: "Nicaragua", dialCode: "+505" },
  { code: "CO", name: "Colombia", dialCode: "+57" },
  { code: "VE", name: "Venezuela", dialCode: "+58" },
  { code: "EC", name: "Ecuador", dialCode: "+593" },
  { code: "PE", name: "Peru", dialCode: "+51" },
  { code: "CL", name: "Chile", dialCode: "+56" },
  { code: "AR", name: "Argentina", dialCode: "+54" },
  { code: "BR", name: "Brasil", dialCode: "+55" },
  { code: "DO", name: "Republica Dominicana", dialCode: "+1" },
  { code: "PR", name: "Puerto Rico", dialCode: "+1" },
  { code: "ES", name: "Espana", dialCode: "+34" }
];

export const defaultPhoneCountryCode = "+506";

export const formatPhoneCountry = country =>
  `${country.name} (${country.dialCode})`;

export default phoneCountries;
